import { FC } from 'react'
import Image from 'next/image'
import { router } from '@lifedot/router'
import Link from 'next/link'
import { css } from '@emotion/react'
import { palette } from '@lifedot/styles/palette'
import { typography } from '@lifedot/styles/typography'
import { rgba } from 'emotion-rgba'

const styles = {
  img: css({
    display: 'block',
    position: 'relative',
    textDecoration: 'none'
  }),
  label: css({
    position: 'absolute',
    top: 0,
    left: 0,
    color: palette.white,
    backgroundColor: rgba(palette.black, 0.6),
    fontWeight: 'bold',
    padding: '0 4px'
  })
}

interface ThumbnailProps {
  path: string
  alt: string
  label?: string
}

export const Thumbnail: FC<ThumbnailProps> = ({ path, alt, label }) => {
  return (
    <>
      <div>
        <Image src={path} width={90} height={67.5} alt={alt} />
      </div>
      {label && <p css={[typography.textS, styles.label]}>{label}</p>}
    </>
  )
}

export interface ThumbnailWithLinkProps extends ThumbnailProps {
  cemeteryId: number
}

export const ThumbnailWithLink: FC<ThumbnailWithLinkProps> = ({
  cemeteryId,
  ...thumbnailProps
}) => {
  return (
    <Link href={router.cemetery(cemeteryId)} passHref prefetch={false}>
      <a css={styles.img}>
        <Thumbnail {...thumbnailProps} />
      </a>
    </Link>
  )
}
